const languageMap: Record<string, string> = {
  url: 'URL',
  http: 'HTTP',
  https: 'HTTPS',
  ruby: 'Ruby',
  php: 'PHP',
  nodejs: 'Node.js',
  java: 'Java',
  js: 'Javascript',
  jquery: 'jQuery',
  react: 'React',
  vuejs: 'Vue.js',
  angular: 'Angular',
  dotnet: 'C#',
  android: 'Android',
  ios: 'iOS',
  jsx: 'React',
  python: 'Python',
  csharp: 'C#',
};

export const getDisplayedLanguage = (language: string) => languageMap[language] ?? language;
